import React from "react";
import { Link } from "react-router-dom";
import logo from '../images/sac-logo-2.png';
function Footer() {
  return (
    <div className="footer">
      <footer className="footer">
        <div className="row p-5">
          <div className="d-sm-none d-none d-md-block col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 text-white text-left">
            <Link className="text-white navbar-brand" to="/">
              <img className="footer-logo mx-auto" alt="Student Athlete Camps Logo" src={logo} />
            </Link>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 text-white text-left">
            <h2 className="footer-title">Links</h2>

            <div className="inline-flex">
              <Link className="text-white" to="/">
                Home
              </Link>
            </div>
            <div className="inline-flex">
              <Link className="text-white" to="/events">
                Events
              </Link>
            </div>
            <div className="inline-flex">
              <Link className="text-white" to="/contact">
                Contact
              </Link>
            </div>
            <div className="inline-flex">
              <Link className="text-white" to="/about">
                About
              </Link>
            </div>



          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 text-white text-left">
            <h2 className="footer-title">Contact</h2>
            <div className="inline-flex">
              Student Athlete Camps
            </div>
            <div className="inline-flex">
              P.O. Box 2080

            </div>
            <div className="inline-flex">
              West Lafayette, IN 47996
            </div>
          </div>
          <div className="d-block d-md-none col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 text-white mx-auto mt-5">
            <Link className="text-white navbar-brand" to="/">
              <img className="footer-logo mx-auto" alt="Student Athlete Camps Logo" src={logo} />
            </Link>
          </div>
          <span class="white foot-span mx-auto mb-1 mt-5">© 2021 Student Athlete Camps</span>
        </div>
      </footer>
    </div>
  );
}

export default Footer;